/* eslint-disable camelcase */
import {
  ComponentComponentsSectionImageRichTextList,
  Enum_Componentcomponentseventlist_Location,
  Enum_Componentcomponentseventlist_Sort,
  Enum_Componentcomponentseventlist_Timing,
  Enum_Componentcomponentsquestion_Type,
  Enum_Form_Type,
  Enum_Technology_Type,
  Event,
  Form,
} from './../../types/schema.d';
import { GetInTouchProps } from '../../components/ui/GetInTouch';
import { RichtextProps } from '../../components/ui/Richtext';
import { SectionCardsProps } from '../../components/ui/SectionCards';
import { SectionBackgroundImageRichTextProps } from '../../components/ui/SectionBackgroundImageRichText';
import { SectionImageRichTextProps } from '../../components/ui/SectionImageRichText';
import { SectionTextButtonsProps } from '../../components/ui/SectionTextButtons';
import { SectionTitleItemListProps } from '../../components/ui/SectionTitleItemList';

import { Content } from '../../components/ui/SectionTextColumns';
import { Testimony } from '../../types/schema';
import { GalleryProps } from '../../components/ui/Gallery';
import { Technology } from '../../types/schema';

export const description =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut';

export const listItems = [
  {
    text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>',
    title: 'Timezone Overlap',
  },
  {
    text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus. Donec porttitor posuere elit ac euismod. Nulla efficitur bibendum libero at fringilla. Sed in ullamcorper dui. Donec finibus pulvinar lectus. Donec ornare enim quis arcu pellentesque, rutrum volutpat odio tristique. Morbi a euismod lectus. Mauris ultrices, purus in faucibus molestie, neque enim euismod libero, quis vestibulum nunc tellus commodo turpis.</p>',
    title: 'Fast Deliveries',
  },
  {
    text: '<p>Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus. Donec porttitor posuere elit ac euismod. Nulla efficitur bibendum libero at fringilla. Sed in ullamcorper dui. Donec finibus pulvinar lectus. Donec ornare enim quis arcu pellentesque, rutrum volutpat odio tristique. Morbi a euismod lectus. Mauris ultrices, purus in faucibus molestie, neque enim euismod libero, quis vestibulum nunc tellus commodo turpis.</p>',
    title: 'Newest Technologies',
  },
  {
    text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet,consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus. consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tristique purus et enim tempor dapibus. Donec porttitor posuere elit ac euismod. Nulla efficitur bibendum libero at fringilla. Sed in ullamcorper dui. Donec finibus pulvinar lectus. Donec ornare enim quis arcu pellentesque, rutrum volutpat odio tristique. Morbi a euismod lectus. Mauris ultrices, purus in faucibus molestie, neque enim euismod libero, quis vestibulum nunc tellus commodo turpis.</p>',
    title: 'Great Adaptability',
  },
];
export const formDefault: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback Default',
  slug: 'storybook-feedback-default',
  type: Enum_Form_Type.Default,
  locale: 'pt',
  successMessage: 'Obrigado pelo feedback!',
  descriptionSection: {
    id: 'ds-desc-sec-1',
    title: 'Formulário padrão',
    description: 'Exemplo do formulário com type "default" e perguntas em uma única página.',
  },
  formSections: [
    {
      id: 'fs-default-1',
      title: 'Sobre você',
      description: 'Algumas perguntas rápidas.',
      questions: [
        {
          id: 'q-default-1',
          title: 'Nome completo',
          hint: 'Resposta curta',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenShortText,
          hash: 'q-default-name',
        },
        {
          id: 'q-default-2',
          title: 'Preferência de contato',
          required: false,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'q-default-contact',
          answerOptions: [
            { id: 'opt-default-1', title: 'E-mail' },
            { id: 'opt-default-2', title: 'Telefone' },
            { id: 'opt-default-3', title: 'WhatsApp' },
          ],
        },
        {
          id: 'q-default-slider',
          title: 'Quantos anos de experiência você tem?',
          hint: '',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.NumberSlider,
          hash: 'q-default-experience',
          minimum: 1,
          maximum: 20,
          allowMore: true,
        },
        {
          id: 'q-default-process',
          title: 'Sobre o processo de compras, o que acontece hoje:',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceCheckbox,
          hash: 'q-default-process',
          answerOptions: [
            { id: 'opt-process-1', title: 'Aprovações ficam travadas esperando gestor ver' },
            { id: 'opt-process-2', title: 'Compradores não sabem o que priorizar' },
            {
              id: 'opt-process-3',
              title: 'Compras são feitas manualmente (telefone/email/whatsapp)',
            },
            { id: 'opt-process-4', title: 'Pedidos demoram para entrar no sistema' },
            { id: 'opt-process-5', title: 'Difícil acompanhar status de pedidos' },
            { id: 'opt-process-6', title: 'Fornecedores não sabem se pedido foi aprovado' },
            { id: 'opt-process-7', title: 'Controlamos as compras em planilhas' },
          ],
        },
      ],
    },
    {
      id: 'fs-default-2',
      title: 'Satisfação',
      description: 'Métricas principais.',
      questions: [
        {
          id: 'q-default-3',
          title: 'Quão satisfeito está?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Nps,
          hash: 'q-default-nps',
        },
        {
          id: 'q-default-4',
          title: 'Comentário adicional',
          hint: 'Opcional',
          required: false,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'q-default-comment',
        },
      ],
    },
  ],
};

export const formWizard: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback Wizard',
  slug: 'storybook-feedback-wizard',
  type: Enum_Form_Type.Wizard,
  locale: 'pt',
  successMessage: 'Valeu pelo feedback!',
  descriptionSection: {
    id: 'ds-desc-sec-2',
    title: 'Formulário wizard',
    description:
      'Exemplo do formulário com type "wizard", liberando o botão de avançar apenas quando a seção está completa.',
  },
  formSections: [
    {
      id: 'fs-wizard-1',
      title: 'Passo 1 — Perfil',
      description: 'Quem está respondendo?',
      questions: [
        {
          id: 'q-wizard-1',
          title: 'Qual seu papel?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'q-wizard-role',
          answerOptions: [
            { id: 'opt-wizard-1', title: 'Desenvolvimento' },
            { id: 'opt-wizard-2', title: 'Produto' },
            { id: 'opt-wizard-3', title: 'Marketing' },
          ],
        },
        {
          id: 'q-wizard-2',
          title: 'Há quanto tempo usa nossos serviços?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'q-wizard-time',
          answerOptions: [
            { id: 'opt-wizard-4', title: 'Menos de 3 meses' },
            { id: 'opt-wizard-5', title: '3 a 12 meses' },
            { id: 'opt-wizard-6', title: 'Mais de 1 ano' },
          ],
        },
      ],
    },
    {
      id: 'fs-wizard-2',
      title: 'Passo 2 — Experiência',
      description: 'Escalas e avaliações.',
      questions: [
        {
          id: 'q-wizard-3',
          title: 'Probabilidade de indicar (NPS)',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Nps,
          hash: 'q-wizard-nps',
        },
        {
          id: 'q-wizard-4',
          title: 'Como avalia o suporte?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.FivePointLikertScale,
          hash: 'q-wizard-likert',
        },
      ],
    },
    {
      id: 'fs-wizard-3',
      title: 'Passo 3 — Detalhes',
      description: 'Campos livres.',
      questions: [
        {
          id: 'q-wizard-5',
          title: 'O que podemos melhorar?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'q-wizard-improve',
        },
        {
          id: 'q-wizard-6',
          title: 'Aceita participar de testes beta?',
          required: false,
          type: Enum_Componentcomponentsquestion_Type.Boolean,
          hash: 'q-wizard-beta',
        },
      ],
    },
  ],
};

export const formWizardConditional: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback Wizard Condicional',
  slug: 'storybook-feedback-wizard-conditional',
  type: Enum_Form_Type.Wizard,
  locale: 'pt',
  successMessage: 'Valeu pelo feedback!',
  descriptionSection: {
    id: 'ds-desc-sec-3',
    title: 'Formulário wizard com seções condicionais',
    description:
      'Exemplo do formulário wizard com seções que aparecem condicionalmente baseado nas respostas anteriores.',
  },
  formSections: [
    {
      id: 'fs-cond-1',
      title: 'Passo 1 — Departamentos',
      description: 'Selecione os departamentos que você trabalha.',
      questions: [
        {
          id: 'q-cond-2',
          title: 'Quais são os principais departamentos? (máximo 3)',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceCheckbox,
          hash: 'principaisDepartamentos',
          answerOptions: [
            { id: 'opt-cond-6', title: 'Recursos Humanos' },
            { id: 'opt-cond-7', title: 'Tecnologia' },
            { id: 'opt-cond-8', title: 'Marketing' },
            { id: 'opt-cond-9', title: 'Financeiro' },
            { id: 'opt-cond-10', title: 'Comercial' },
          ],
        },
      ],
    },
    {
      id: 'fs-cond-2',
      title: 'Passo 2 — Detalhes RH',
      description: 'Seção específica para quem trabalha com RH.',
      conditionalShowQuestion: 'principaisDepartamentos',
      conditionalShowAnswer: 'Recursos Humanos',
      questions: [
        {
          id: 'q-cond-3',
          title: 'Quantos funcionários você gerencia?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'q-cond-rh-funcionarios',
          answerOptions: [
            { id: 'opt-cond-11', title: '1 a 10' },
            { id: 'opt-cond-12', title: '11 a 50' },
            { id: 'opt-cond-13', title: 'Mais de 50' },
          ],
        },
        {
          id: 'q-cond-4',
          title: 'Usa sistema de gestão de pessoas?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Boolean,
          hash: 'q-cond-rh-sistema',
        },
      ],
    },
    // Exemplo: seção condicional baseada em RADIO (aparece quando "Mais de 50")
    {
      id: 'fs-cond-2b',
      title: 'Passo 2B — RH Avançado (Radio condicional)',
      description: 'Aparece se você gerencia Mais de 50 funcionários.',
      conditionalShowQuestion: 'q-cond-rh-funcionarios',
      conditionalShowAnswer: 'Mais de 50',
      questions: [
        {
          id: 'q-cond-2b-1',
          title: 'Quais desafios você enfrenta com times grandes?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'q-cond-rh-desafios',
        },
      ],
    },
    // Exemplo: seção condicional baseada em BOOLEAN (aparece quando "Sim")
    {
      id: 'fs-cond-2c',
      title: 'Passo 2C — RH com Sistema (Boolean condicional)',
      description: 'Aparece se você usa um sistema de gestão de pessoas.',
      conditionalShowQuestion: 'q-cond-rh-sistema',
      conditionalShowAnswer: 'Sim',
      questions: [
        {
          id: 'q-cond-2c-1',
          title: 'Qual sistema você utiliza?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenShortText,
          hash: 'q-cond-rh-qual-sistema',
        },
      ],
    },
    {
      id: 'fs-cond-3',
      title: 'Passo 3 — Detalhes Tecnologia',
      description: 'Seção específica para quem trabalha com Tecnologia.',
      conditionalShowQuestion: 'principaisDepartamentos',
      conditionalShowAnswer: 'Tecnologia',
      questions: [
        {
          id: 'q-cond-5',
          title: 'Qual sua stack principal?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'q-cond-tech-stack',
          answerOptions: [
            { id: 'opt-cond-14', title: 'Frontend' },
            { id: 'opt-cond-15', title: 'Backend' },
            { id: 'opt-cond-16', title: 'Fullstack' },
            { id: 'opt-cond-17', title: 'DevOps' },
          ],
        },
      ],
    },
    {
      id: 'fs-cond-4',
      title: 'Passo 4 — Finalização',
      description: 'Comentários finais.',
      questions: [
        {
          id: 'q-cond-6',
          title: 'Comentários adicionais',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'q-cond-comentarios',
        },
      ],
    },
  ],
};

export const formWizardPromptQuestion: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback Wizard com PromptQuestion',
  slug: 'storybook-feedback-wizard-prompt',
  type: Enum_Form_Type.Wizard,
  locale: 'pt',
  successMessage: 'Obrigado pelo feedback!',
  descriptionSection: {
    id: 'ds-desc-sec-prompt',
    title: 'Formulário wizard com perguntas dinâmicas',
    description:
      'Exemplo do formulário wizard com seção que carrega perguntas dinamicamente baseado nas respostas anteriores.',
  },
  formSections: [
    {
      id: 'fs-prompt-1',
      title: 'Passo 1 — Informações Básicas',
      description: 'Responda algumas perguntas iniciais.',
      questions: [
        {
          id: 'q-prompt-1',
          title: 'Qual seu nome?',
          hint: 'Digite seu nome completo',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenShortText,
          hash: 'prompt-nome',
        },
        {
          id: 'q-prompt-2',
          title: 'Qual área você trabalha?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'prompt-area',
          answerOptions: [
            { id: 'opt-prompt-1', title: 'Tecnologia' },
            { id: 'opt-prompt-2', title: 'Marketing' },
            { id: 'opt-prompt-3', title: 'Vendas' },
            { id: 'opt-prompt-4', title: 'RH' },
          ],
        },
      ],
    },
    {
      id: 'fs-prompt-2',
      title: 'Passo 2 — Perguntas Personalizadas',
      description: 'Com base nas suas respostas anteriores, preparamos perguntas adicionais.',
      promptQuestion: 'Gere perguntas baseadas no contexto do usuário',
      questions: [], // Perguntas serão carregadas dinamicamente
    },
    {
      id: 'fs-prompt-3',
      title: 'Passo 3 — Finalização',
      description: 'Última etapa do formulário.',
      questions: [
        {
          id: 'q-prompt-final',
          title: 'Algum comentário adicional?',
          hint: 'Opcional',
          required: false,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'prompt-comentario-final',
        },
      ],
    },
  ],
};

export const formWizardPromptResultWithQuestion: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback Wizard com PromptResult (com pergunta)',
  slug: 'storybook-feedback-wizard-prompt-result-question',
  type: Enum_Form_Type.Wizard,
  locale: 'pt',
  successMessage: 'Obrigado pelo feedback gerado via IA!',
  descriptionSection: {
    id: 'ds-desc-sec-prompt-result-q',
    title: 'Último passo com processamento de resultado',
    description:
      'Exemplo de seção final com promptResult: mostra loader, depois exibe uma pergunta e o botão de finalizar.',
  },
  formSections: [
    {
      id: 'fs-prompt-result-q-1',
      title: 'Passo 1 — Contexto',
      description: 'Perguntas iniciais para gerar o resultado.',
      questions: [
        {
          id: 'q-prq-1',
          title: 'Descreva brevemente seu projeto',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'prompt-result-contexto',
        },
        {
          id: 'q-prq-2',
          title: 'Qual o principal objetivo?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'prompt-result-objetivo',
          answerOptions: [
            { id: 'opt-prq-1', title: 'Gerar leads' },
            { id: 'opt-prq-2', title: 'Aumentar retenção' },
            { id: 'opt-prq-3', title: 'Validar produto' },
          ],
        },
      ],
    },
    {
      id: 'fs-prompt-2',
      title: 'Passo 2 — Perguntas Personalizadas',
      description: 'Com base nas suas respostas anteriores, preparamos perguntas adicionais.',
      promptQuestion: 'Gere perguntas baseadas no contexto do usuário',
      questions: [], // Perguntas serão carregadas dinamicamente
    },
    {
      id: 'fs-prompt-result-q-2',
      title: 'Passo 2 — Síntese automatizada',
      description: 'Processamos suas respostas para gerar um resumo.',
      promptResult: 'Gerar síntese e recomendação final',
      loaderText: 'Gerando a análise personalizada...',
      questions: [
        {
          id: 'q-prq-3',
          title: 'O resumo gerado está adequado?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Boolean,
          hash: 'prompt-result-validacao',
        },
      ],
    },
  ],
};

export const formFeedbackQuestionAllTypes: Form = {
  documentId: '',
  localizations: [],
  title: 'Feedback com todos os tipos de pergunta',
  slug: 'storybook-feedback-all-types',
  type: Enum_Form_Type.Default,
  locale: 'pt',
  successMessage: 'Obrigado pelo feedback!',
  descriptionSection: {
    id: 'ds-desc-sec-all-types',
    title: 'Todos os tipos do FeedbackQuestion',
    description:
      'Formulário de storybook que exibe cada tipo de pergunta disponível no componente FeedbackQuestion.',
  },
  formSections: [
    {
      id: 'fs-all-types-1',
      title: 'Tipos de pergunta',
      description: 'Preencha os exemplos abaixo.',
      questions: [
        {
          id: 'q-all-1',
          title: 'OpenShortText — Qual seu nome?',
          hint: 'Resposta curta',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenShortText,
          hash: 'all-open-short-text',
        },
        {
          id: 'q-all-2',
          title: 'OpenLongText — Conte sobre seu desafio atual',
          hint: 'Resposta longa',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.OpenLongText,
          hash: 'all-open-long-text',
        },
        {
          id: 'q-all-3',
          title: 'MultipleChoiceRadio — Qual canal preferido?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceRadio,
          hash: 'all-multiple-choice-radio',
          answerOptions: [
            { id: 'opt-all-1', title: 'E-mail' },
            { id: 'opt-all-2', title: 'Telefone' },
            { id: 'opt-all-3', title: 'WhatsApp' },
          ],
        },
        {
          id: 'q-all-4',
          title: 'MultipleChoiceCheckbox — Departamentos (max 3)',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.MultipleChoiceCheckbox,
          hash: 'departamentos',
          answerOptions: [
            { id: 'opt-all-4', title: 'Produto' },
            { id: 'opt-all-5', title: 'Tecnologia' },
            { id: 'opt-all-6', title: 'Marketing' },
            { id: 'opt-all-7', title: 'Vendas' },
          ],
        },
        {
          id: 'q-all-5',
          title: 'NPS — Probabilidade de indicar',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Nps,
          hash: 'all-nps',
        },
        {
          id: 'q-all-6',
          title: 'FivePointLikertScale — Avalie o atendimento',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.FivePointLikertScale,
          hash: 'all-likert',
        },
        {
          id: 'q-all-7',
          title: 'Boolean — Você recomendaria a App Masters?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.Boolean,
          hash: 'all-boolean',
        },
        {
          id: 'q-all-8',
          title: 'NumberSlider — Quantos anos de experiência?',
          required: true,
          type: Enum_Componentcomponentsquestion_Type.NumberSlider,
          hash: 'all-number-slider',
          minimum: 0,
          maximum: 10,
          allowMore: true,
          steper: 1,
        },
      ],
    },
  ],
};

export { mockPromptQuestions } from '../../utils/mockPromptQuestions';

export const allTechnologies = [];

export const sectionTitleItemList = {
  first: {
    backgroundColor: 'white',
    contentOrientation: 'row',
    text: '<h3>Rich Text</h3><h6>A software development company focused on custom-made web, mobile and desktop applications ranging from MVPs to fully developed SaaS applicationsOur mission is to create quality</h6><p>software applications that are user-friendly, functional, and high performing, with a deep focus on our clients needs and processes. At every stage of development, we provide test versions to get feedback and make sure we are on the right track.</p>',
    listType: 'accordion',
    items: listItems,
  } as SectionTitleItemListProps,
  second: {
    backgroundColor: 'lightGradient',
    contentOrientation: 'row',
    text: '<h3>Rich Text</h3><p>A software development company focused on custom-made web, mobile and desktop applications ranging from MVPs to fully developed SaaS applicationsOur mission is to create quality software applications that are user-friendly, functional, and high performing, with a deep focus on our clients needs and processes. At every stage of development, we provide test versions to get feedback and make sure we are on the right track.</p>',
    listType: 'numeric',
    items: listItems,
  } as SectionTitleItemListProps,
  third: {
    backgroundColor: 'lightGradient',
    contentOrientation: 'column',
    text: '<h3>Rich Text</h3><p>A software development company focused on custom-made web, mobile and desktop applications ranging from MVPs to fully developed SaaS applicationsOur mission is to create quality software applications that are user-friendly, functional, and high performing, with a deep focus on our clients needs and processes. At every stage of development, we provide test versions to get feedback and make sure we are on the right track.</p>',
    listType: 'accordion',
    items: listItems,
  } as SectionTitleItemListProps,
};

export const blog = {
  title: 'Lorem ipsum',
  description,
  author: {
    name: 'John Doe',
  },
};

export const cards = [
  {
    id: '1',
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1625072865/new_technologies_8def143b68_d9b1493cf8_1ba1e4aef2.png',
    title: 'Commitment',
    description:
      'Allocate a fully dedicated development team that will provide high quality and short delivery time.',
  },
  {
    id: '2',
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1625072865/new_technologies_8def143b68_d9b1493cf8_1ba1e4aef2.png',
    title: 'Competency',
    description:
      'Hiring top tech professionals and provide continuous learning/teaching of newest technologies to our staff.',
  },
  {
    id: '3',
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1625072865/new_technologies_8def143b68_d9b1493cf8_1ba1e4aef2.png',
    title: 'Creativity',
    description:
      'Brazilian agility and creativity is well known worldwide (jogo de cintura), this is a key soft skill that our workers possess to be solution-oriented and bring customized results.',
  },
  {
    id: '4',
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1625072865/new_technologies_8def143b68_d9b1493cf8_1ba1e4aef2.png',
    title: 'Communication',
    description:
      'Great communication between the client/team as well as within the team is key to success. our team is fully bilingual in ENG/PT which allows a smooth understanding.',
  },
];

export const developmentDetails = {
  devTime: 329,
  devMonths: 2,
  devCommits: 221,
  whereToFind: [
    {
      link: 'https://play.google.com/store/apps/details?id=io.appmasters.goodburger',
      image:
        'https://res.cloudinary.com/appmasters-io/image/upload/v1624479243/google_play_29886f4ef9.png',
    },
    {
      link: 'https://good-burger.firebaseapp.com/',
      image:
        'https://res.cloudinary.com/appmasters-io/image/upload/v1624467430/chrome_browser_badge_2a505ce903.png',
    },
  ],
  locale: 'pt',
};

export const dottedList = {
  first: {
    title: 'DottedList',
    topics: [
      {
        id: '1',
        title: 'Lorem ipsum dolor sit amet',
        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        id: '1',
        title: 'Lorem ipsum dolor sit amet',
        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      {
        id: '1',
        title: 'Lorem ipsum dolor sit amet',
        body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
    ],
  },
  second: {
    title: 'Title example',
    cardImage:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1625158848/undraw_shared_workspace_hwky_a5418a954c.svg',
    isCard: true,
    topics: [
      {
        title: 'title',
        id: '1',
        body: 'Lorem ipsum dolor sit amet',
      },
      {
        title: 'title',
        id: '1',
        body: 'Lorem ipsum dolor sit amet',
      },
      {
        title: 'title',
        id: '1',
        body: 'Lorem ipsum dolor sit amet',
      },
    ],
  },
};

const imageUrl =
  'https://picsum.photos/id/1/600/600.jpg?hmac=MPNEzEtk9H80_Lx07TNC3IQI5NSmEVbQezCzscDCo7Q';

const createImageArray = (value: number) => Array.from({ length: value }, () => imageUrl);

export const gallery: { props: GalleryProps; subtitle: string }[] = [
  {
    subtitle: 'Columns: 2 / Size: medium / galleryImagePosition: Covered',
    props: {
      columns: 2,
      images: createImageArray(4),
      size: 'medium',
      cloudinaryOriginalURLs: createImageArray(4),
    },
  },
  {
    subtitle: 'Columns: 2 / Size: large / galleryImagePosition: Covered',
    props: {
      columns: 2,
      images: createImageArray(4),
      size: 'large',
      cloudinaryOriginalURLs: createImageArray(4),
    },
  },
  {
    subtitle: 'Columns: 2 / Size: large / galleryImagePosition: Contained',
    props: {
      columns: 2,
      images: createImageArray(4),
      size: 'large',
      cloudinaryOriginalURLs: createImageArray(4),
      galleryImagePosition: 'contained',
    },
  },
  {
    subtitle: 'isCarousel: true / carouselWidth: content / carouselBackground: primary',
    props: {
      isCarousel: true,
      images: createImageArray(6),
      cloudinaryOriginalURLs: createImageArray(6),
      carouselWidth: 'content',
      carouselBackground: 'primary',
    },
  },
  {
    subtitle: 'isCarousel: true / carouselWidth: content / carouselBackground: white',
    props: {
      isCarousel: true,
      images: createImageArray(6),
      cloudinaryOriginalURLs: createImageArray(6),
      carouselWidth: 'content',
      carouselBackground: 'white',
    },
  },
  {
    subtitle: 'isCarousel: true / carouselWidth: page',
    props: {
      isCarousel: true,
      images: createImageArray(6),
      cloudinaryOriginalURLs: createImageArray(6),
      carouselWidth: 'page',
    },
  },
];

export const getInTouch = {
  title: 'Lorem ipsum',
  description,
  button: 'Submit',
  background: 'white',
} as GetInTouchProps;

export const richtext = {
  first: {
    body: '<h1>App Masters Academy</h1><p>For our team members, being developers go beyond any regular job, it’s a passion, a passion that we love to share through teaching. We believe that our knowledge and experience allow us to offer unique training that will be a great added value for individuals as well as for companies. We offer training on the technologies we work with and believe in. Face-to-face coaching can take place in our office, where we have all the necessary equipments to carry them out. Online teaching can also take place whether in English or in Portuguese and can be adapted to the needs of our customers</p>',
    default: false,
  } as RichtextProps,
  second: {
    body: '<h1>App Masters Academy</h1><p>For our team members, being developers go beyond any regular job, it’s a passion, a passion that we love to share through teaching. We believe that our knowledge and experience allow us to offer unique training that will be a great added value for individuals as well as for companies. We offer training on the technologies we work with and believe in. Face-to-face coaching can take place in our office, where we have all the necessary equipments to carry them out. Online teaching can also take place whether in English or in Portuguese and can be adapted to the needs of our customers</p>',
    default: true,
  } as RichtextProps,
};

export const sectionCards = {
  first: {
    cards: [
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
        icon: 'icons/fast-deliveries.svg',
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
        icon: 'icons/newest-technologies.svg',
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
        icon: 'icons/great-adaptability.svg',
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
        icon: 'icons/timezone-overlap.svg',
      },
    ],
    cardsPosition: 'inline',
    backgroundColor: 'blue',
    content:
      '<h1>App Masters Academy</h1><p>For our team members, being developers go beyond any regular job, it’s a passion, a passion that we love to share through teaching. We believe that our knowledge and experience allow us to offer unique training that will be a great added value for individuals as well as for companies. We offer training on the technologies we work with and believe in. Face-to-face coaching can take place in our office, where we have all the necessary equipments to carry them out. Online teaching can also take place whether in English or in Portuguese and can be adapted to the needs of our customers</p>',
    callToAction: {
      title: 'Lorem ipsum dolor sit amet',
      destinationUrl: 'https://appmasters.io',
    },
  } as SectionCardsProps,
  second: {
    cards: [
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
    ],
    backgroundColor: 'darkBlue',
  } as SectionCardsProps,
  third: {
    cards: [
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: true,
      },
    ],
    cardsPosition: 'left',
    content:
      '<h1>App Masters Academy</h1><p>For our team members, being developers go beyond any regular job, it’s a passion, a passion that we love to share through teaching. We believe that our knowledge and experience allow us to offer unique training that will be a great added value for individuals as well as for companies. We offer training on the technologies we work with and believe in. Face-to-face coaching can take place in our office, where we have all the necessary equipments to carry them out. Online teaching can also take place whether in English or in Portuguese and can be adapted to the needs of our customers</p>',
    callToAction: {
      title: 'Lorem ipsum dolor sit amet',
      destinationUrl: 'https://appmasters.io',
    },
  } as SectionCardsProps,
  fourth: {
    cards: [
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: false,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: false,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: false,
      },
      {
        title: 'Lorem ipsum dolor sit amet',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        showNumber: false,
      },
    ],
    cardsPosition: 'right',
    backgroundColor: 'blue',
    content:
      '<h1>App Masters Academy</h1><p>For our team members, being developers go beyond any regular job, it’s a passion, a passion that we love to share through teaching. We believe that our knowledge and experience allow us to offer unique training that will be a great added value for individuals as well as for companies. We offer training on the technologies we work with and believe in. Face-to-face coaching can take place in our office, where we have all the necessary equipments to carry them out. Online teaching can also take place whether in English or in Portuguese and can be adapted to the needs of our customers</p>',
    callToAction: {
      title: 'Lorem ipsum dolor sit amet',
      destinationUrl: 'https://appmasters.io',
    },
  } as SectionCardsProps,
};

export const sectionTextButtons = {
  backgroundColor: 'lightGradient',
  text: '<h1>How about building something great together?</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam a sapien fermentum, volutpat dui mollis, mollis justo. Quisque consequat fermentum pulvinar. Sed risus sem, congue id augue et, lacinia euismod tortor. Quisque varius ex nisi, a tincidunt neque efficitur a. Nullam tincidunt sapien eu nibh laoreet aliquam</p>',
  buttons: [{ title: 'Get in touch with us', action: '/' }],
  buttonsAlignment: 'left',
} as SectionTextButtonsProps;

export const sectionBackgroundImageRichText = {
  first: {
    textPosition: 'left',
    backgroundColor: 'darkGradient',
    backgroundImage: '/bg.png',
    text: `<p>${description} ${description}</p>`,
  } as SectionBackgroundImageRichTextProps,
  second: {
    textPosition: 'center',
    backgroundColor: 'darkGradient',
    backgroundImage: '/bg.png',
    text: `<p>${description} ${description}</p>`,
  } as SectionBackgroundImageRichTextProps,
  third: {
    textPosition: 'right',
    backgroundColor: 'darkGradient',
    backgroundImage: '/bg.png',
    text: `<p>${description} ${description}</p>`,
  } as SectionBackgroundImageRichTextProps,
};

export const sectionImageRichText = {
  first: {
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1670933209/appmasters_team_8b4abfaac0.png?updated_at=2022-12-14T14:51:47.198Z',
    imageFit: 'absolutFull',
    imageProportion: 'half',
    backgroundColor: 'lightGradient',
    text: `<p>${description} ${description}</p>`,
  } as SectionImageRichTextProps,
  second: {
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1670933209/appmasters_team_8b4abfaac0.png?updated_at=2022-12-14T14:51:47.198Z',
    imageFit: 'absolutBottom',
    imageProportion: 'half',
    backgroundColor: 'lightGradient',
    text: `<p>${description} ${description}</p>`,
  } as SectionImageRichTextProps,
  third: {
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1670933209/appmasters_team_8b4abfaac0.png?updated_at=2022-12-14T14:51:47.198Z',
    imageFit: 'centerAndFit',
    imageProportion: 'half',
    backgroundColor: 'lightGradient',
    text: `<p>${description} ${description}</p>`,
  } as SectionImageRichTextProps,
  fourth: {
    image:
      'https://res.cloudinary.com/appmasters-io/image/upload/v1670933209/appmasters_team_8b4abfaac0.png?updated_at=2022-12-14T14:51:47.198Z',
    imageFit: 'centerAndCover',
    imageProportion: 'oneThird',
    backgroundColor: 'darkGradient',
    text: `<p>${description} ${description}</p>`,
  } as SectionImageRichTextProps,
};

export const generateMockContent = (mockContent: Partial<Content>): Content => ({
  linkDestination: '/',
  linkText: 'Learn More',
  content:
    '<h2>Welcome</h2><h3>App Masters Academy</h3><p>For our <a href="/">team members</a>, being developers go beyond any regular job, it’s a passion, a passion that we <b>love</b> to share through teaching.</p>',
  ...mockContent,
});

export const mockTestimonials = {
  compact: true,
  testimonies: [
    {
      createdAt: 'date',
      updatedAt: 'date',
      name: 'April Dela Vega',
      clientCountry: 'EUA',
      image:
        'https://res.cloudinary.com/appmasters-io/image/upload/c_scale,w_100,h_100,q_70,f_auto/image_14_ebd0fcf61c_b4f6a7e742',
      occupation: 'CEO',
      companyName: 'Breakout Technologies',
      testimony:
        'App Masters was instrumental in making our proof of concept in Distributed Payment Conciliation based on Blockchain technology. Professionals of excellence and easy personal relationship.',
    },
    {
      createdAt: 'date',
      updatedAt: 'date',
      name: 'April Dela Vega',
      image:
        'https://res.cloudinary.com/appmasters-io/image/upload/c_scale,w_100,h_100,q_70,f_auto/image_14_ebd0fcf61c_b4f6a7e742',
      occupation: 'CEO',
      companyName: 'Breakout Technologies',
      testimony:
        'My first experience with app development became something much simpler and more enjoyable after the partnership with App Masters. They worked in order to meet my expectations that, many times, were even surpassed. We are very satisfied with the development of the project, and even more, with the results.',
    },
    {
      createdAt: 'date',
      updatedAt: 'date',
      name: 'April Dela Vega',
      clientCountry: 'Canada',
      image:
        'https://res.cloudinary.com/appmasters-io/image/upload/c_scale,w_100,h_100,q_70,f_auto/image_14_ebd0fcf61c_b4f6a7e742',
      occupation: 'CEO',
      companyName: 'Breakout Technologies',
      testimony:
        'The attention given to the project by the App Masters team, since the first contact, brought us the necessary security to bring our idea to life. We had (and continue to have) an excellent experience and we can say, without any fear, that technical competence, unparalleled support, and attention to details are the company differentials.',
    },
  ] as unknown as Testimony[],
};

export const MockSectionImageRichTextList = {
  icon: {
    mediaType: 'icon',
    SectionImageRichTextListItems: [
      {
        image: { data: { attributes: { url: '/icons/fast-deliveries.svg' } } },
        text: '<h1>Lorem ipsum dolor sit amet</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p>',
      },
      {
        image: { data: { attributes: { url: '/icons/great-adaptability.svg' } } },
        text: '<h1>Lorem ipsum dolor sit amet</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p>',
      },
    ],
  } as unknown as ComponentComponentsSectionImageRichTextList,
  image: {
    mediaType: 'image',
    SectionImageRichTextListItems: [
      {
        image: { data: { attributes: { url: '/contactCardBackground.svg' } } },
        text: '<h1>Lorem ipsum dolor sit amet</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p>',
      },
      {
        image: { data: { attributes: { url: '/appmasters-metaimage.png' } } },
        text: '<h1>Lorem ipsum dolor sit amet</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas rutrum laoreet consectetur. Nam efficitur, ex vitae dapibus fringilla, diam quam feugiat leo, id convallis enim diam nec nisl. Donec ullamcorper bibendum bibendum. Nullam quis odio felis. Ut vel mollis neque.</p>',
      },
    ],
  } as unknown as ComponentComponentsSectionImageRichTextList,
};

export const MockTechnologies = [
  {
    title: 'MySQL',
    slug: 'mysql',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744345/mysql_87a2317566.png',
    },
  },
  {
    title: 'PostgreSQL',
    slug: 'postgres',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744360/postgresql_5dc555c069.png',
    },
  },
  {
    title: 'GitHub Actions',
    slug: 'github-actions',
    locale: 'pt',
    priority: 'high',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744320/github_actions_6f81344365.png',
    },
  },
  {
    title: 'Node.Js',
    slug: 'node',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744354/node_js_420ba2a9f5.png',
    },
  },
  {
    title: 'React',
    slug: 'react',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744362/react_29a7745224.png',
    },
  },
  {
    title: 'TypeScript',
    slug: 'typescript',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744368/typescript_d9c1669716.png',
    },
  },
  {
    title: 'Firebase',
    slug: 'firebase',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744315/firebase_290341aff1.png',
    },
  },
  {
    title: 'Elastic Search',
    slug: 'elastic-search',
    locale: 'pt',
    priority: 'low',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744309/elastic_search_2f129a254c.png',
    },
  },
  {
    title: 'Google Cloud Platform',
    slug: 'gcp',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744324/google_cloud_platform_c3afc42b63.png',
    },
  },
  {
    title: 'Amazon Web Services',
    slug: 'aws',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1628952950/2560px_Amazon_Web_Services_Logo_svg_b22086ab17.png',
    },
  },
  {
    title: 'Heroku',
    slug: 'heroku',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744333/heroku_8c593a25b9.png',
    },
  },
  {
    title: 'Next.js',
    slug: 'nextjs',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744352/next_js_e018bb7b17.png',
    },
  },
  {
    title: 'Vue.js',
    slug: 'vuejs',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744370/vue_js_5f5f5e5e5e.png',
    },
  },
  {
    title: 'Flutter',
    slug: 'flutter',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744315/firebase_290341aff1.png',
    },
  },
  {
    title: 'React Native',
    slug: 'react-native',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744362/react_29a7745224.png',
    },
  },
  {
    title: 'Python',
    slug: 'python',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744354/node_js_420ba2a9f5.png',
    },
  },
  {
    title: 'Docker',
    slug: 'docker',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744320/github_actions_6f81344365.png',
    },
  },
  {
    title: 'Kubernetes',
    slug: 'kubernetes',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744324/google_cloud_platform_c3afc42b63.png',
    },
  },
  {
    title: 'Stripe',
    slug: 'stripe',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1628952950/2560px_Amazon_Web_Services_Logo_svg_b22086ab17.png',
    },
  },
  {
    title: 'Redis',
    slug: 'redis',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744309/elastic_search_2f129a254c.png',
    },
  },
  {
    title: 'GraphQL',
    slug: 'graphql',
    locale: 'pt',
    priority: 'high',
    featured: true,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744368/typescript_d9c1669716.png',
    },
  },
  {
    title: 'Strapi',
    slug: 'strapi',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Service,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744333/heroku_8c593a25b9.png',
    },
  },
  {
    title: 'Styled Components',
    slug: 'styled-components',
    locale: 'pt',
    priority: 'medium',
    featured: false,
    type: Enum_Technology_Type.Library,
    logo: {
      documentId: '',
      url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1624744345/mysql_87a2317566.png',
    },
  },
] as unknown as Technology[];

const eventImageUrl =
  'https://res.cloudinary.com/appmasters-io/image/upload/v1704822705/0b46d7fe4486e076042c3e6021b5dd5a81292d29_47c654ae03.png';

function getDateFromNow(days: number) {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString();
}

export const MockEventsPT = [
  {
    __typename: 'Event',
    title: 'Campus Party - Salvador',
    startDate: getDateFromNow(5),
    endDate: null,
    country: 'Brasil',
    state: 'Bahia',
    city: 'Salvador',
    type: 'presential',
    url: 'https://brasil.campus-party.org/',
    description:
      'A Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.',
    image: {
      data: {
        attributes: {
          url: eventImageUrl,
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Campus Party - Brasília',
    startDate: getDateFromNow(-5),
    endDate: null,
    country: 'Brasil',
    state: 'Distrito Federal',
    city: 'Brasília',
    type: 'presential',
    url: 'https://brasil.campus-party.org/',
    description:
      'A Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.\n\nA Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.',
    image: {
      data: {
        attributes: {
          url: eventImageUrl,
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'CES Consumer Technology',
    startDate: getDateFromNow(15),
    endDate: null,
    country: 'Estados Unidos',
    state: 'Nevada',
    city: 'Las Vegas',
    type: 'presential',
    url: 'https://www.ces.tech/',
    description:
      'Estão disponíveis as inscrições para a CES ® 2024, que será realizada de 9 a 12 de janeiro, na cidade de Las Vegas.\n\nAproveite as oportunidades de negócios globais que a CES proporciona, possibilitando encontros com parceiros, clientes, mídia, investidores e líderes políticos de diversos setores e do mundo inteiro, tudo em um único local.\n\nNão deixe passar a oportunidade de participar do evento de tecnologia mais influente do mundo.',
    image: {
      data: {
        attributes: {
          url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1705570762/CES_270x300_c0e374edf6.png',
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Campus Party - Salvador',
    startDate: getDateFromNow(-15),
    endDate: null,
    country: 'Brasil',
    state: 'Bahia',
    city: 'Salvador',
    type: 'presential',
    url: 'https://brasil.campus-party.org/',
    description:
      'A Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.\n\nA Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.',
    image: {
      data: {
        attributes: {
          url: eventImageUrl,
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Campus Party - São Paulo',
    startDate: getDateFromNow(-45),
    endDate: null,
    country: 'Brasil',
    state: 'São Paulo',
    city: 'São Paulo',
    type: 'presential',
    url: 'https://brasil.campus-party.org/',
    description:
      'A Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.\nA Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.',
    image: {
      data: {
        attributes: {
          url: eventImageUrl,
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Commerce Week',
    startDate: getDateFromNow(45),
    endDate: null,
    country: 'Estados Unidos',
    state: 'New York',
    city: 'New York',
    type: null,
    url: 'https://event.adweek.com/commerceweek-2024/',
    description:
      'Nunca foi tão crucial combinar a narrativa da marca com as vendas, e as inovações tecnológicas, como a inteligência artificial, possibilitam isso de maneiras novas e dinâmicas.\n\nDurante a Commerceweek, vamos explorar as habilidades, capacidades e investimentos internos necessários para oferecer as melhores experiências de compra da marca em um ambiente digital, assim como o papel da criatividade – em todas as suas formas – na venda de maneira eficiente e consistente. Vamos aproveitar as preferências e prioridades do consumidor e do cliente por meio de uma análise de dados poderosa.',
    image: {
      data: {
        attributes: {
          url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1705570761/Commerce_Week_270x300_36a9ea6300.png',
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Web Summit Qatar',
    startDate: getDateFromNow(60),
    endDate: null,
    country: 'Catar',
    state: null,
    city: 'Catar',
    type: null,
    url: 'https://qatar.websummit.com/',
    description:
      'Além da Web Summit em Lisboa, Web Summit Rio no Rio de Janeiro, Collision em Toronto e RISE em Hong Kong, agora temos a Web Summit Qatar, que será realizada no Centro de Exposições e Convenções de Doha (DECC) de 26 a 29 de fevereiro de 2024.\n\nO evento no Catar reunirá mais de 7.500 pessoas por três motivos principais. Primeiro, contará com palestrantes incríveis e experientes, prontos para compartilhar seus conhecimentos. Segundo, oferecerá oportunidades de networking incomparáveis, permitindo que os empreendedores se conectem com outros profissionais do setor. Por fim, a Web Summit Qatar utilizará um software proprietário que maximizará a experiência dos participantes.\n\nA importância desse evento vai além de apenas reunir pessoas. Ele ajudará a conectar uma nova geração',
    image: {
      data: {
        attributes: {
          url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1705570761/Web_Summit_QATAR_270x3001_df97f9687b.png',
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'AW Outlook 2024',
    startDate: getDateFromNow(-5),
    endDate: null,
    country: 'Estados Unidos',
    state: 'New York',
    city: 'New York',
    type: null,
    url: 'https://event.adweek.com/outlook-2024/',
    description:
      '2024 será um ano desafiador e emocionante, com uma eleição presidencial, eventos esportivos de grande importância, avanços tecnológicos e uma economia instável. Para os profissionais de marketing, será essencial ter determinação, visão e tomar decisões estratégicas para alcançar o sucesso e manter o impulso ao longo do ano.\n\nNo evento da Adweek, reuniremos as mentes mais brilhantes do setor para discutir o futuro próximo e focar nas principais questões que terão relevância: como acompanhar as demandas dos consumidores, como os criativos e criadores podem se manter à frente da cultura, como os canais de mídia dinâmicos estão impulsionando os negócios e qual será o impacto da inteligência artificial na forma como trabalhamos.\n\nAlém disso, discutiremos como todas',
    image: {
      data: {
        attributes: {
          url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1705570761/AW_Outlook_2024_270x300_6193d77ff5.png',
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Bossa Summit 2024',
    startDate: getDateFromNow(90),
    endDate: null,
    country: 'Brasil',
    state: 'São Paulo',
    city: 'São Paulo',
    type: null,
    url: 'https://bossasummit.com.br/',
    description:
      'O Bossa Summit é um encontro que ocorre todos os anos e reúne executivos, investidores, empreendedores e profissionais da mídia com o objetivo de transformar o mundo, por meio do compartilhamento de ideias e impulsionamento do mercado de startups.\n\nConsiderado o maior evento do Brasil dedicado às startups e investidores, o Bossa Summit tem como propósito acelerar o mercado de investimentos em startups ao conectar e capacitar todo o ecossistema.\n\nDurante o evento, são realizadas palestras inspiradoras, apresentação de casos reais e oportunidades de negócios, que levam os participantes a um novo nível. Na última edição, o encontro reuniu 10 mil pessoas em busca de conexões e transformações.\n\nO Bossa Summit é um ambiente propício para o crescimento e a inovação, trazendo um impulso significativo ao',
    image: {
      data: {
        attributes: {
          url: 'https://res.cloudinary.com/appmasters-io/image/upload/v1705570761/Bossa_Summit_270x300_157f4cba2c.png',
        },
      },
    },
  },
  {
    __typename: 'Event',
    title: 'Campus Party - São Paulo',
    startDate: getDateFromNow(120),
    endDate: null,
    country: 'Brasil',
    state: 'São Paulo',
    city: 'São Paulo',
    type: 'presential',
    url: 'https://brasil.campus-party.org/',
    description:
      'A Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.\n\nA Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.\n\nA Campus Party é o maior festival de tecnologia, empreendedorismo, ciência e disruptividade do mundo, com mais de 70 edições realizadas em 30 países.\n\nUm ambiente imersivo de disrupção, educação e criatividade, onde nossas comunidades são parte essencial da experiência, mobilizando a transformação.',
    image: {
      data: {
        attributes: {
          url: eventImageUrl,
        },
      },
    },
  },
] as unknown as Event[];

export const MockEventListProps = {
  first: {
    events: MockEventsPT,
    year: `${new Date().getFullYear()}`,
    sort: Enum_Componentcomponentseventlist_Sort.Asc,
  },
  second: {
    events: MockEventsPT,
    year: `${new Date().getFullYear()}`,
    sort: Enum_Componentcomponentseventlist_Sort.Asc,
    location: Enum_Componentcomponentseventlist_Location.NoBrasil,
    timing: Enum_Componentcomponentseventlist_Timing.Future,
  },
  third: {
    events: MockEventsPT,
    year: `${new Date().getFullYear()}`,
    sort: Enum_Componentcomponentseventlist_Sort.Desc,
    location: Enum_Componentcomponentseventlist_Location.NoBrasil,
    timing: Enum_Componentcomponentseventlist_Timing.Past,
  },
  fourth: {
    events: MockEventsPT,
    year: `${new Date().getFullYear()}`,
    sort: Enum_Componentcomponentseventlist_Sort.Desc,
    location: Enum_Componentcomponentseventlist_Location.ForaDoBrasil,
    timing: Enum_Componentcomponentseventlist_Timing.Future,
  },
  fifth: {
    events: MockEventsPT,
    year: `${new Date().getFullYear()}`,
    sort: Enum_Componentcomponentseventlist_Sort.Asc,
    location: Enum_Componentcomponentseventlist_Location.ForaDoBrasil,
    timing: Enum_Componentcomponentseventlist_Timing.Past,
  },
};
